import { useState, useCallback } from "react";

export interface ControllableOptions<T> {
  value?: T;
  defaultValue?: T;
  onChange?: (value: T) => void;
}

function useControllable<T>({
  value,
  defaultValue,
  onChange,
}: ControllableOptions<T>): [T, (next: T) => void] {
  // sirf uncontrolled ke liye internal state
  const [uncontrolled, setUncontrolled] = useState<T>(defaultValue as T);

  const isControlled = value !== undefined;
  const currentValue = (isControlled ? value : uncontrolled) as T;

  const setValue = useCallback(
    (next: T) => {
      // agar controlled nahi hai tabhi internal state update
      if (!isControlled) {
        setUncontrolled(next);
      }
      onChange?.(next);
    },
    [isControlled, onChange],
  );

  return [currentValue, setValue];
}

export default useControllable;

// import React from "react";
// import { useEffect, useState } from "react";

// export interface ControllableOptions<T> {
//   value?: T;
//   defaultValue?: T;
//   onChange?: (value: T) => void;
// }

// function useControllable<T>({
//   value,
//   defaultValue,
//   onChange,
// }: ControllableOptions<T>): [T, (next: T) => void] {
//   const [internal, setInternal] = useState<T>(
//     value !== undefined ? value : (defaultValue as T),
//   );

//   useEffect(() => {
//     if (value !== undefined) {
//       setInternal(value);
//     }
//   }, [value]);

//   const set = (next: T) => {
//     setInternal(next);
//     onChange?.(next);
//   };

//   return [internal, set];
// }

// export default useControllable;
